// extracted by mini-css-extract-plugin
export default {"container":"StagesCarousel_container__5vkCF"};